import React from "react";
import Proptypes from "prop-types";
import cn from "classnames";

import "./divider-message.scss";

const block = "divider-message";

const DividerMessage = ({ message, className }) => (
  <div role="separator" className={cn(block, className)}>
    <div className={`${block}__line`} />
    <span className={`${block}__text`}>{message}</span>
    <div className={`${block}__line`} />
  </div>
);

DividerMessage.propTypes = {
  message: Proptypes.string.isRequired,
  className: Proptypes.string
};

export default DividerMessage;
